import React, { useState, useEffect, useRef } from 'react';
import { Card, CardBody, CardFooter, Row, Col } from 'reactstrap';
import { useHistory } from "react-router-dom";
import ValidationSummary from 'devextreme-react/validation-summary';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import { TextBox } from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { postLogin } from "../../utils/api";
import { notificacionError } from '../../utils/alerts';

export default function Login() {
    let buttonRef = (null);
    let inputUSER = useRef(null);
    let inputPSW = useRef(null);
    const history = useHistory();
    const [form, setForm] = useState({ username: "", password: "" });
    const [load, setLoad] = useState({ text: "Iniciar Sesion", loadVisible: false, loadDisabled: false });
    const [deshabilitar1, setDeshabilitar1] = useState(false);
    const [deshabilitar2, setDeshabilitar2] = useState(false);

    const formChange = (type, e) => {
        setForm({ ...form, [type]: e.value.trim() });
    }

    const handleLogin = () => {
        setLoad({ text: "", loadVisible: true, loadDisabled: true });
        setDeshabilitar1(true);
        setDeshabilitar2(true);
        if (form.username && form.password) {
            postLogin(form).then((resp) => {
                if (resp?.data?.success) {
                    history.push('/pasesPendientes');
                } else {
                    let errorMsg = (resp?.data !== undefined) ? resp.data?.error : resp === undefined ? "Intentelo Nuevamente ó contacte con el administrador del sistema" : resp;
                    notificacionError(errorMsg);
                }
                setLoad({ text: "Iniciar Sesion", loadVisible: false });
                setDeshabilitar1(false);
                setDeshabilitar2(false);
            });
        } else {
            setLoad({ text: "Iniciar Sesion", loadVisible: false });
            setDeshabilitar1(false);
            setDeshabilitar2(false);
            if (!form.username) {
                notificacionError("Ingrese un usuario valido");
            } else if (!form.password) {
                notificacionError("Ingrese una contraseña valida");
            } else if (!form.username && !form.password) {
                notificacionError("Ingrese usuario y contraseña valida");
            }
        }
    }

    const handleEnter = () => {
        inputPSW.current.instance.focus();
    }

    return (
        <div className="content d-flex justify-content-center">
            <Card style={{ width: '23em', marginTop: '9em' }}>
                <CardBody>
                    <Row>
                        <Col className="text-center">
                            <label className="col-form-label fs-6 fw-bold">Autorización de Pases</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={{ size: 12 }}>
                            <label className="col-form-label fs-6 fw-bold">Usuario</label>
                            <TextBox
                                ref={inputUSER}
                                disabled={deshabilitar1}
                                showClearButton={true}
                                placeholder="Usuario"
                                valueChangeEvent="keyup"
                                onEnterKey={handleEnter}
                                onValueChanged={(e) => formChange("username", e)}
                                value={form.username} >
                                <Validator>
                                    <RequiredRule message="Usuario Requerido" />
                                </Validator>
                            </TextBox>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={{ size: 12 }}>
                            <label className="col-form-label fs-6 fw-bold">Contraseña</label>
                            <TextBox
                                ref={inputPSW}
                                disabled={deshabilitar2}
                                mode="password"
                                focusStateEnabled={true}
                                showClearButton={true}
                                placeholder="Contraseña"
                                valueChangeEvent="keyup"
                                onValueChanged={(e) => formChange("password", e)}
                                value={form.password}
                                onEnterKey={() => handleLogin()}>
                                <Validator>
                                    <RequiredRule message="Contraseña Requerida" />
                                </Validator>
                            </TextBox>
                        </Col>
                    </Row>
                </CardBody>
                <CardFooter>
                    <Row>
                        <Col sm={{ size: 12, order: 3 }} className="text-center">
                            <ValidationSummary id="summary"></ValidationSummary>
                            <Button
                                className="mt-2"
                                ref={buttonRef}
                                id="button"
                                text="Iniciar Sesion"
                                type="success"
                                icon="chevronright"
                                useSubmitBehavior={true}
                                onClick={handleLogin}
                                disabled={load.loadDisabled}
                            >
                                <LoadIndicator className="button-indicator" visible={load.loadVisible} />
                                <span className="dx-button-text">{load.text}</span>
                            </Button>
                        </Col>
                    </Row>
                </CardFooter>
            </Card>
        </div>
    )
}
